var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"page":'registration'}},[_c('template',{slot:"title"},[_c('div',[_c('title-component',{attrs:{"title":_vm.$t('auth.registration.title'),"type":"h1"}})],1)]),_c('registration-form')],2)}
var staticRenderFns = []

export { render, staticRenderFns }